import { Dayjs } from "dayjs";

export interface ILegalEntityResponseItem {
  ownership_id: string;
  name: string;
  full_name: string;
  registration_number: string;
  ogrn: string;
  okpo: string | null;
  address: {
    country_id: number;
    postcode: string | null;
    region: string | null;
    area: string | null;
    city: string | "Undefined";
    address: string;
  };
  certificate: {
    issue_by: string;
    issued_at: string;
    number: string;
  };
}

export interface ILicenseFormValues {
  id?: number;
  number: string;
  issued_date: Dayjs | null;
  issued_by: string;
}

export interface IPostLicenseDTO {
  number: string;
  issued_date: string | null;
  issued_by: string | null;
}
export interface IPutLicenseDTO extends IPostLicenseDTO {
  id: number;
}

export enum EOrganizationValue {
  Individual = 1,
  IndividualEntrepreneur = 2,
  LegalEntity = 3,
}

export interface IActivitySphere {
  id: number;
  category_name: string;
  name: string;
  parent_id: number | null;
}

export interface ILicense {
  id: number;
  partner_id: number;
  number: string;
  issued_date: string;
  issued_by: string;
  path: string | null;
  is_original_uploaded: boolean;
  license: string;
  updated_at: string;
  created_at: string;
}
export interface IOwnership {
  eng_value: string;
  id: number;
  value: string;
}
